module.exports = __webpack_public_path__ + "img/frame_three.386378b2.png";